import { Icon } from "@chakra-ui/react";
const LightDOWNArrow = () => {
  return (
    <>
      <Icon
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17" cy="17" r="17" fill="#D2E4E8" />
        <circle cx="17" cy="17" r="10" fill="black" />
        <path d="M17 21L22.1962 15H11.8038L17 21Z" fill="#D2E4E8" />
      </Icon>
    </>
  );
};
export default LightDOWNArrow;
